/// <reference path="../resetPassword/resetPassword.js" />

(function () {
    'use strict';
    app.controller('adminManagementController', ['$scope', '$location', '$cookies', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', 'adminManagementService', function ($scope, $location, $cookies, AuthenticationService, progressBarService, $rootScope, $timeout, adminManagementService) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem("appInfo") == undefined || getLocalValue('userRole') != 'SAdmin') {
            $location.path('/login');
            return
        }

        $scope.isError = false;
        $scope.isSuccess = false;

        var hideMessage = function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.message = ''
        }

        $scope.search = {
            eSpectraAdminEmailId: "",
            eSpectraInstitutionName: "",
            eSpectraAdminName: ""
        }

        var approved = [];
        var rejected = [];
        var pending = [];

        $scope.validateData = function () {
            approved = [];
            rejected = [];
            pending = [];
            $scope.sendEmailToApprovedUsers = [];

            $.each($scope.AffiliationAdmins.affiliation, function (index, value) {
                var defaultValue = value.eSpectraDefaultAdminStatus;
                var currentValue = value.eSpectraAdminStatus;
                if (currentValue != defaultValue && currentValue == "Approved") {
                    approved.push(value.eSpectraRoleAssignID);
                    $scope.sendEmailToApprovedUsers.push({
                        eSpectraAdminEmailId: value.eSpectraAdminEmailId,
                        eSpectraInstitutionName: value.eSpectraInstitutionName
                    });

                } else if (currentValue != defaultValue && currentValue == "Pending") {
                    pending.push(value.eSpectraRoleAssignID);
                }
                else if (currentValue != defaultValue && currentValue == "Rejected") {
                    rejected.push(value.eSpectraRoleAssignID);
                }
            });
            if (approved.length > 0 || pending.length > 0 || rejected.length > 0) {
                $('#confirmSubmit').modal('show');
            } else {
                $scope.isError = true;
                $scope.isSuccess = false;
                $scope.message = 'There are no changes available for submit data to server.';
                //$timeout(hideMessage, 10000);
            }
        }

        $scope.update = function () {
            $('#confirmSubmit').modal('hide');
            progressBarService.showProgressBar();
            adminManagementService.update(approved.join(), pending.join(), rejected.join()).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {
                    if ($scope.sendEmailToApprovedUsers.length > 0) {
                        senNotificationTodApprovedUsers($scope.sendEmailToApprovedUsers);
                    }
                    $scope.isError = false;
                    $scope.isSuccess = true;
                    //$timeout(hideMessage, 10000);
                    $scope.message = 'Data updated successfully.';
                    $scope.getData();
                    progressBarService.hideProgressBar();
                }
            });
        };

        var senNotificationTodApprovedUsers = function (approvedUsers) {
            adminManagementService.senNotificationTodApprovedUsers(approvedUsers);
        };

        $scope.getData = function () {
            progressBarService.showProgressBar();

            adminManagementService.getData().then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {
                    $scope.AffiliationAdmins = response.data;
                }

                progressBarService.hideProgressBar();
            });
        }

        $scope.getData();

        $scope.exportReportData = function () {

            progressBarService.showProgressBar();
            var today, dd, mm, yyyy, currentDate, startDate, endDate, parameter;
            today = new Date();
            dd = today.getDate();
            mm = today.getMonth() + 1; //January is 0!

            yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            currentDate = mm + '/' + dd + '/' + yyyy;
            var fileName = 'InstitutionAdministratorsReport_' + currentDate + '.csv';

            var affiliationReport = angular.copy($scope.filteredAdmins);
            var length = $scope.filteredAdmins.length;
            $(affiliationReport).each(function (index) {
                delete affiliationReport[index].eSpectraAdminStatus;
                delete affiliationReport[index].eSpectraRoleAssignID;
                delete affiliationReport[index].$$hashKey;
            });

            
            var csv = convertArrayOfObjectsToCSV({
                data: affiliationReport
            }, length);

            BlobDownloadCSV('InstitutionAdministratorsReport_' + currentDate + '.csv', csv)

            progressBarService.hideProgressBar();
        }

        function convertArrayOfObjectsToCSV(args,length) {

            var result, ctr, keys, columnDelimiter, lineDelimiter, data, headers;

            data = args.data || null;
            if (data == null || !length) {
                return null;
            }

            columnDelimiter = args.columnDelimiter || ',';
            lineDelimiter = args.lineDelimiter || '\n';


            keys = Object.keys(data[0]).slice(1);

            headers = ["Customer Name",
                "Customer Email",
                "Affiliation Name",
                "Status"
                ]

            result = 'Report Name' + columnDelimiter + "Institution Administrators Report" + lineDelimiter;
            //result += 'Transaction Range - Start Date' + columnDelimiter + startDate + lineDelimiter;
            //result += 'Transaction Range - End Date' + columnDelimiter + endDate + lineDelimiter + lineDelimiter;
            result += headers.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function (item) {

                ctr = 0;
                keys.forEach(function (key) {
                    if (ctr > 0) result += columnDelimiter;

                    result += item[key];
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }

    }]);

})();